import { render } from "./VirtualMeetingComprehensiveDetails.vue?vue&type=template&id=0542ef0c&scoped=true&ts=true"
import script from "./VirtualMeetingComprehensiveDetails.vue?vue&type=script&lang=ts"
export * from "./VirtualMeetingComprehensiveDetails.vue?vue&type=script&lang=ts"

import "./VirtualMeetingComprehensiveDetails.vue?vue&type=style&index=0&id=0542ef0c&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0542ef0c"]])

export default __exports__